import React from 'react';
import PropTypes from 'prop-types';
import cname from './style.module.scss';

export const MinusButton = (props) => (
  <svg
    {...props}
    className={`${cname.icon} ${props.className}`}
    role='img'
    aria-label='Decrement'
    xmlns='http://www.w3.org/2000/svg'
    width='62'
    height='62'
    viewBox='0 0 62 62'
    fill='none'>
    <circle cx='31' cy='31' r='31' fill='#FAAC48' />
    <rect
      x='16.2227'
      y='33.1113'
      width='4.22222'
      height='29.5556'
      rx='2.11111'
      transform='rotate(-90 16.2227 33.1113)'
      fill='#003E6B'
    />
  </svg>
);

MinusButton.propTypes = {
  /**
   * className
   */
  className: PropTypes.string,
};

MinusButton.defaultProps = {
  className: '',
};
